'use client';

import { FormattedMessage, useIntl } from 'react-intl';
import InfoDividerDot from '@alltrails/core/components/InfoDividerDot';
import { minutesToFormattedTime } from '@alltrails/data-formatting/dateTimeFormatters';
import { getFormattedDistance } from '@alltrails/data-formatting/distanceFormatters';

type LengthAndDurationProps = {
  meters: number;
  minutes: number;
  showLengthLabel?: boolean;
  useMetric?: boolean;
  decimalPlaces?: number;
  averageTimeToComplete?: {
    value: string;
    unit: string;
  };
};

const LengthAndDuration = ({
  meters,
  minutes,
  showLengthLabel = false,
  useMetric = false,
  decimalPlaces = 1,
  averageTimeToComplete
}: LengthAndDurationProps) => {
  const intl = useIntl();
  return (
    <>
      {showLengthLabel ? (
        <>
          <FormattedMessage defaultMessage="Length:" />{' '}
        </>
      ) : null}
      {getFormattedDistance(intl, meters, useMetric, { maximumFractionDigits: decimalPlaces })}
      {minutes ? (
        <>
          <InfoDividerDot />
          {averageTimeToComplete
            ? `${intl.formatMessage({
                defaultMessage: 'Est.'
              })} ${averageTimeToComplete.value} ${averageTimeToComplete.unit}`
            : minutesToFormattedTime({ intl, totalMinutes: minutes, isEstimate: true })}
        </>
      ) : null}
    </>
  );
};

export default LengthAndDuration;
